import React from "react";
import PageContainerAuth from "../../components/common/PageContainerAuth";
import MailingRuleDetailsSection from "../../components/pages/mailing-rules/details/MailingRuleDetailsSection";

export function MailingRuleDetails() {
    return (
        <PageContainerAuth section="mailings-mailing" pageTitle="Configuration d'envoi" backDestination={"/mailing-rules"}>
            <MailingRuleDetailsSection />
        </PageContainerAuth>
    );
}